import styled from "styled-components";

export const Wrapper = styled.div<{ $islayoutUsed?: boolean }>`
  width: 100%;
  height: ${({ $islayoutUsed }) =>
    $islayoutUsed ? "calc(100vh - 60px)" : "100vh"};
  display: flex;
  align-items: center;
  padding: 52px;
  background: #fff;
`;

export const ErrorContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const ErrorHeader = styled.h1`
  font-family:
    Ubuntu,
    Open sans,
    arial;
  color: #004470;
  font-weight: 700;
  font-size: 52px;
  line-height: 60px;
  letter-spacing: -2%;
  @media (max-width: 1000px) {
    font-size: 36px;
    line-height: 44px;
  }
`;

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 32px;
  background-color: #004470;
  color: white;
  font-family: "Open Sans", arial;
  font-weight: 600;
  font-size: 1rem;
  border: 0px;
  width: fit-content;
  &:hover {
    background-color: #00365a;
    cursor: pointer;
  }
`;

export const ErrorBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family:
    Open sans,
    arial;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -2%;
  color: var(--unumWarnNeutralDark);
  font-style: normal;

  @media (max-width: 1000px) {
    font-size: 14px;
    line-height: 18px;
  }
`;
